var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 19
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Profile_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h19v19H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Profile_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 19v-2.375c0-2.613 4.275-4.751 9.5-4.751s9.5 2.138 9.5 4.751V19zM4.749 4.751A4.75 4.75 0 1 1 9.5 9.5a4.75 4.75 0 0 1-4.751-4.749"
}))));
export { SvgProfile as ReactComponent };
export default __webpack_public_path__ + "static/media/Profile.d4523b41.svg";